function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "77px",
    height: "105px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93a0b1",
    d: "M -0.5,-0.5 C 25.1667,-0.5 50.8333,-0.5 76.5,-0.5C 76.5,33.1667 76.5,66.8333 76.5,100.5C 75.5,100.5 74.5,100.5 73.5,100.5C 73.8316,67.9957 73.4982,35.6624 72.5,3.5C 53.0043,2.33759 33.3376,2.17092 13.5,3C 14.9047,4.26918 16.5714,4.76918 18.5,4.5C 30.6322,6.53282 42.6322,9.19948 54.5,12.5C 55.8333,39.1667 55.8333,65.8333 54.5,92.5C 38.6797,96.3711 23.013,100.371 7.5,104.5C 5.5,104.5 3.5,104.5 1.5,104.5C 1.16667,103.5 0.5,102.833 -0.5,102.5C -0.5,68.1667 -0.5,33.8333 -0.5,-0.5 Z M 47.5,54.5 C 44.3915,54.7359 41.3915,54.4025 38.5,53.5C 38.5,52.1667 38.5,50.8333 38.5,49.5C 30.5,48.5 30.5,47.5 38.5,46.5C 38.2865,44.8561 38.6198,43.3561 39.5,42C 42.146,41.5026 44.8127,41.3359 47.5,41.5C 47.5,45.8333 47.5,50.1667 47.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adb8c5",
    d: "M 72.5,3.5 C 54.3256,3.16988 36.3256,3.50322 18.5,4.5C 16.5714,4.76918 14.9047,4.26918 13.5,3C 33.3376,2.17092 53.0043,2.33759 72.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bec9",
    d: "M 72.5,3.5 C 73.4982,35.6624 73.8316,67.9957 73.5,100.5C 74.5,100.5 75.5,100.5 76.5,100.5C 76.5,100.833 76.5,101.167 76.5,101.5C 75.1667,101.5 73.8333,101.5 72.5,101.5C 72.5,68.8333 72.5,36.1667 72.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#adb7c4",
    d: "M 44.5,44.5 C 44.6716,45.4916 44.3382,46.1583 43.5,46.5C 42.6236,46.6309 41.9569,46.2975 41.5,45.5C 42.325,44.6143 43.325,44.281 44.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f6f7",
    d: "M 44.5,44.5 C 45.7759,45.3864 45.7759,46.3864 44.5,47.5C 43.8933,47.3764 43.56,47.0431 43.5,46.5C 44.3382,46.1583 44.6716,45.4916 44.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaedf0",
    d: "M 43.5,49.5 C 43.56,48.9569 43.8933,48.6236 44.5,48.5C 45.4287,49.6888 45.762,51.0222 45.5,52.5C 44.1667,52.5 42.8333,52.5 41.5,52.5C 41.2627,51.209 41.596,50.209 42.5,49.5C 42.3691,50.3764 42.7025,51.0431 43.5,51.5C 44.7733,50.7435 44.7733,50.0768 43.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#95a3b3",
    d: "M 42.5,49.5 C 42.8333,49.5 43.1667,49.5 43.5,49.5C 44.7733,50.0768 44.7733,50.7435 43.5,51.5C 42.7025,51.0431 42.3691,50.3764 42.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7eaed",
    d: "M 38.5,53.5 C 41.3915,54.4025 44.3915,54.7359 47.5,54.5C 46.2067,55.1582 44.7067,55.4915 43,55.5C 41.0145,55.4313 39.5145,54.7647 38.5,53.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoor);
export default __webpack_public_path__ + "static/media/ico-door.a3cd4e19fdedaca01805f199f07d34e8.svg";
export { ForwardRef as ReactComponent };